import { cva } from '@/styled-system/css';

export const tagRecipe = cva({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'top',
  },
  variants: {
    tone: {
      critical: {
        backgroundColor: 'Tag.critical.bg',
        color: 'Tag.critical.text',
      },
      info: {
        backgroundColor: 'Tag.info.bg',
        color: 'Tag.info.text',
      },
      success: {
        backgroundColor: 'Tag.success.bg',
        color: 'Tag.success.text',
      },
      warning: {
        backgroundColor: 'Tag.warning.bg',
        color: 'Tag.warning.text',
      },
      gray: {
        backgroundColor: 'Tag.gray.bg',
        color: 'Tag.gray.text',
      },
      green: {
        backgroundColor: 'Tag.green.bg',
        color: 'Tag.green.text',
      },
      purple: {
        backgroundColor: 'Tag.purple.bg',
        color: 'Tag.purple.text',
      },
      aqua: {
        backgroundColor: 'Tag.aqua.bg',
        color: 'Tag.aqua.text',
      },
      orange: {
        backgroundColor: 'Tag.orange.bg',
        color: 'Tag.orange.text',
      },
      transparent: {
        backgroundColor: 'Tag.transparent.bg',
        color: 'Tag.transparent.text',
      },
      blue: {
        backgroundColor: 'Tag.blue.bg',
        color: 'Tag.blue.text',
      },
      teal: {
        backgroundColor: 'Tag.teal.bg',
        color: 'Tag.teal.text',
      },
      yellow: {
        backgroundColor: 'Tag.yellow.bg',
        color: 'Tag.yellow.text',
      },
      red: {
        backgroundColor: 'Tag.red.bg',
        color: 'Tag.red.text',
      },
    },
    size: {
      sm: {
        borderRadius: 'Tag.sm',
        paddingInline: 'Tag.sm.padding.horz',
        paddingBlock: 'Tag.sm.padding.vert',
        gap: 'Tag.sm.gap.label-toIcon',
      },
      md: {
        borderRadius: 'Tag.md',
        paddingInline: 'Tag.md.padding.horz',
        paddingBlock: 'Tag.md.padding.vert',
        gap: 'Tag.md.gap.label-toIcon',
      },
    },
  },
});
